import { __values } from "tslib";
import { logger } from './logger';
var MAX_PROPERTY_KEYS = 1000;
var _isValidObject = function (properties) {
    if (Object.keys(properties).length > MAX_PROPERTY_KEYS) {
        logger.warn('too many properties. Skipping operation');
        return false;
    }
    for (var key in properties) {
        if (typeof key !== 'string') {
            logger.warn('invalid properties format. Skipping operation');
            return false;
        }
        var value = properties[key];
        if (!isValidProperties(key, value))
            return false;
    }
    return true;
};
var isValidProperties = function (property, value) {
    var e_1, _a;
    if (typeof property !== 'string')
        return false;
    if (Array.isArray(value)) {
        try {
            for (var value_1 = __values(value), value_1_1 = value_1.next(); !value_1_1.done; value_1_1 = value_1.next()) {
                var valueElement = value_1_1.value;
                if (Array.isArray(valueElement)) {
                    logger.warn('invalid array element type ', typeof valueElement);
                    return false;
                }
                else if (typeof valueElement === 'object') {
                    return _isValidObject(value);
                }
                else if (!(typeof valueElement === 'number' || typeof valueElement === 'string')) {
                    logger.warn('invalid array element type ', typeof valueElement);
                    return false;
                }
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (value_1_1 && !value_1_1.done && (_a = value_1.return)) _a.call(value_1);
            }
            finally { if (e_1) throw e_1.error; }
        }
    }
    else if (typeof value === 'object') {
        return _isValidObject(value);
    }
    else if (!(typeof value === 'number' || typeof value === 'string')) {
        logger.warn('invalid value type ', typeof value);
        return false;
    }
    return true;
};
export { isValidProperties };
//# sourceMappingURL=validateProperties.js.map